import { select, withQuery } from '@panel/commons/core/themev2';
import React from 'react';
import styled, { keyframes } from 'styled-components';

const SkeletonContainer = styled.div`
  max-width: 870px;
  width: 100%;
  height: 246px;
  border-radius: 12px;
  border: solid 1px ${select('midLightGray')};
  display: flex;
  margin: 0;
  padding: 0;
  overflow: hidden;
  ${withQuery.md.down()} {
    flex-direction: column;
    height: 480px;
  }
`;

const loadingAnimation = keyframes`
  0%{background-position:0% 54%}
  50%{background-position:100% 47%}
  100%{background-position:0% 54%}
`;

const ImageSkeleton = styled.div`
  width: 35%;
  background-color: ${select('midLightGray')};
  height: 100%;
  background: linear-gradient(267deg, ${select('midLightGray')}, ${select('middleGray')});
  background-size: 300% 300%;
  animation: ${loadingAnimation} 2s ease infinite;
  animation-delay: 1s;
  ${withQuery.md.down()} {
    width: 100%;
    height: 300px;
  }
`;

const InfoSkeleton = styled.div`
  width: 65%;
  background-color: ${select('white')};
  height: 100%;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  > * {
    background: linear-gradient(267deg, ${select('midLightGray')}, ${select('middleGray')});
    background-size: 300% 300%;
    animation: ${loadingAnimation} 2s ease infinite;
  }
  > div {
    width: 60%;
    border-radius: 12px;
    height: 20px;
    background-color: ${select('midLightGray')};
    margin-bottom: 50px;
  }
  p {
    width: 80%;
    border-radius: 12px;
    margin-bottom: 20px;
    height: 20px;
    background-color: ${select('midLightGray')};
  }
  p:nth-of-type(2) {
    width: 60%;
  }
  p:nth-of-type(3) {
    width: 70%;
  }
  ${withQuery.md.down()} {
    width: 100%;
    height: 346px;
    > div {
      width: 85%;
    }
    p:nth-of-type(2) {
      width: 70%;
    }
    p:nth-of-type(3) {
      width: 90%;
    }
  }
`;

function PreviewSkeleton() {
  return (
    <SkeletonContainer>
      <ImageSkeleton />
      <InfoSkeleton>
        <div />
        <p />
        <p />
        <p />
      </InfoSkeleton>
    </SkeletonContainer>
  );
}

export { PreviewSkeleton };
